import React, { memo } from 'react';
import { useSnackbar } from 'notistack';
import { SnackbarProps } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const CloseButton = ({ onClick: onClickProps }) => {
  // 一回このコンポーネント内で関数を定義しないと、closeSnackbarが動かない
  const onClick = () => {
    onClickProps();
  };
  return (
    <IconButton size="small" onClick={onClick}>
      <CloseIcon />
    </IconButton>
  );
};

const Snackbar = memo(
  ({
    message,
    options = {},
  }: {
    message: string | Array<string>,
    options?: SnackbarProps,
  }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    React.useEffect(() => {
      if (Array.isArray(message)) {
        message.forEach((m) =>
          enqueueSnackbar(m, {
            preventDuplicate: true,
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            action: <CloseButton onClick={closeSnackbar} />,
            ...options,
          }),
        );
      } else if (message) {
        enqueueSnackbar(message, {
          preventDuplicate: true,
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
          action: <CloseButton onClick={closeSnackbar} />,
          ...options,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message, enqueueSnackbar, options]);

    return <div />;
  },
);

export default Snackbar;
